<template>
  <button
    @click="$emit('click')"
    :disabled="isLoading || disabled"
    :class="{ 'max-h-11': size == 'normal', 'max-h-14': size == 'large' }"
  >
    <div
      :class="{
        'state-layer rounded-full py-2.5 px-6 h-full': true,
        'pl-4 pr-6': isLoading || (icon && iconOrientation === 'start'),
        'pr-4 pl-6': !isLoading && (icon && iconOrientation === 'end')
      }"
    >
      <div
        :class="[
          'flex items-center justify-center gap-2 h-full',
          iconOrientation === 'end' ? 'flex-row-reverse' : 'flex-row',
        ]"
      >
        <div v-if="isLoading">
          <Icon name="loading" class="fill-inherit h-[18px] w-[18px]" />
        </div>
        <div v-else-if="icon">
          <Icon :name="icon" class="fill-inherit h-[18px] w-[18px]" />
        </div>
        <div><slot></slot></div>
      </div>
    </div>
  </button>
</template>

<script>
import Icon from '@/Components/Icon.vue'

export default {
  name: 'Button',
  components: { Icon },
  props: {
    isLoading: { type: Boolean, default: false },
    icon: String,
    iconOrientation: {
      type: String,
      default: 'start',
      validator: value => ['start', 'end'].includes(value),
    },
    size: {
      type: String,
      default: 'normal',
      validator: value => ['normal', 'large'].includes(value),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
